import store from '../../store'
// import router from '../../router'
// import dialogs from '../common/dialogs'
// import vPersonForm from './PersonForm'
import people from '../people/index.js'
import forms from '../common/forms.js'
import companyBank from './companyBank.js'
// import formats from '../../api/formats'

export default {
  createStrategy (cxt, type) {
    switch (type) {
      case 'COMPANY_BANK': {
        return companyBank.createStrategy(cxt)
      }
    }
  },
  selectCompanyBankByInn (cxt, refCode, itemId) {
    const _f = (v) => v || '-'
    return new Promise((resolve, reject) => {
      this.getCompanyBanks(refCode)
      .then((banks) => {
        let items = []
        banks.forEach(ba => {
          items.push({value: ba.id, text: `${_f(ba.name)}: ${_f(ba.bankName)}, ${_f(ba.bankAccount)}`})
        })
        forms.selectItem(items, [], 'Выберите Банк').then((data) => resolve(data))
      },
      () => {
        console.log('selectCompanyBankByInn - error')
        return
      })
    })
  },

  openCompanyBank (itemId, refCode, companyNameShort, clientCompanyId) {
    return new Promise((resolve, reject) => {
      let strategy = this.createStrategy(null, 'COMPANY_BANK')
      strategy.setParentProps({refCode: refCode, companyNameShort: companyNameShort, clientCompanyId: clientCompanyId})
      forms.openFormStg(strategy, itemId).then(data => resolve(data))
    })
  },
  openCompanyContact (itemId, refCode, companyNameShort, clientCompanyId) {
    return new Promise((resolve, reject) => {
      let strategy = people.createStrategy(null, 'CONTACT')
      strategy.setParentProps({refCode: refCode, nameShort: companyNameShort, clientCompanyId: clientCompanyId})
      forms.openFormStg(strategy, itemId).then(data => resolve(data))
    })
  },
  getCompanyRef (refCode) {
    return new Promise((resolve, reject) => {
      store.dispatch('getFavoriteRefs', refCode).then(data => resolve(data[0]))
    })
  },

  getCompanyBanks (refCode) {
    return store.dispatch('getCompanyBanks', refCode)
  }

}



// WEBPACK FOOTER //
// ./src/components/favorite/index.js